// Stores
import { SearchCriteriaModel } from 'stores/models/search-criteria-model';
import { SearchQueryAdapter } from 'stores/adapters/search-query-adapter';
import { SearchResultsStore } from 'stores/search-results-store';

// Vendor
import * as queryString from 'query-string';

const HOTEL_NAME = '1'; // eg: `hicago-Mariott-Suites-Deerfield`
const INFOSITE = '2'; // eg: `Hotel-Information`

export const generateAddAnotherPropertyURL = (searchCriteria: SearchCriteriaModel, searchResults: SearchResultsStore): object => {
  const sqaParsedOut = SearchQueryAdapter.parseOut(Object.assign({}, searchCriteria.toJSON([HOTEL_NAME, INFOSITE])));

  searchResults.expandForm = true;

  return {
    pathname: '/Hotel-Search',
    search: queryString.stringify({ ...sqaParsedOut, useRewards: false })
  };
};
